module.exports = __webpack_public_path__ + "f6afdb6282dbc143f635c20037a9728e.svg";